var wm_scroll_var, wm_current_scroll_position;


function wm_throttle(func, delay) {
var timer = null;

return function () {
  var context = this, args = arguments;

  if (timer === null) {
    timer = setTimeout(function () {
      func.apply(context, args);
      timer = null;
    }, delay);
  }
};
}

jQuery(document).ready(function($){
    function wm_sticky_nav() {
        wm_current_scroll_position = $(this).scrollTop();
        $('body').toggleClass('nav-is-visible', wm_scroll_var > wm_current_scroll_position);
        $('body').toggleClass('nav-is-hidden', wm_scroll_var < wm_current_scroll_position);
        wm_scroll_var = wm_current_scroll_position;
    }

    $(window).scroll(wm_throttle(wm_sticky_nav, 200));

});
